import React from 'react';
import './Books.css';

import BookCard from '../components/Books/BookCard/BookCards';
import {books} from '../content/books/books';
import {bookCoverMap} from '../content/books/book-covers';

function Books() {
  const featured = books.find((b) => b.isLatest) ?? books[0];
  const rest = books.filter((b) => b.id !== featured.id);

  return (
    <div className='Books'>
      <div className='bookpage'>
        <h1 className='m-xl-3 text-center'>Books</h1>

        {/* Featured (latest) */}
        {/* Featured (latest) */}
        <div className='row m-auto g-0 g-sm-5 justify-content-center'>
          <div className='col-12 col-lg-10'>
            <BookCard
              book={featured}
              coverSrc={bookCoverMap[featured.coverKey]}
              size='featured'
            />
          </div>
        </div>

        {/* Rest */}
        <div className='row g-0 g-sm-5 m-auto mb-5 pb-5 justify-content-center'>
          {rest.map((book) => (
            <div
              key={book.id}
              className='col-12 col-md-6 col-lg-4 p-sm-2 p-xl-3'>
              <BookCard
                book={book}
                coverSrc={bookCoverMap[book.coverKey]}
                size='small'
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Books;
